import { render, staticRenderFns } from "./TempPrescription.vue?vue&type=template&id=0474494d&scoped=true"
import script from "./TempPrescription.vue?vue&type=script&lang=js"
export * from "./TempPrescription.vue?vue&type=script&lang=js"
import style0 from "./TempPrescription.vue?vue&type=style&index=0&id=0474494d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0474494d",
  null
  
)

export default component.exports